// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M8.06 10.48H7.94V10.35H8.06V10.46M7.7 5.48L8.02 8.04L8.33 5.48L7.7 5.48Z',
];
